import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	currentuser: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	standardissuetypes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subtaskissuetypes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	releasedversions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unreleasedversions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	standardissuetypesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subtaskissuetypesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	currentuser: {
		id: 'jql-builder-basic.utils.get-function-label.currentuser',
		defaultMessage: 'Current User',
		description: 'Current User option in issue navigator refinement dropdown.',
	},
	standardissuetypes: {
		id: 'jql-builder-basic.utils.get-function-label.standardissuetypes',
		defaultMessage: 'All standard issue types',
		description: 'Standard issue type option in issue navigator refinement dropdown.',
	},
	subtaskissuetypes: {
		id: 'jql-builder-basic.utils.get-function-label.subtaskissuetypes',
		defaultMessage: 'All sub-task issue types',
		description: 'Sub-task issue type option in issue navigator refinement dropdown.',
	},
	releasedversions: {
		id: 'jql-builder-basic.utils.get-function-label.releasedversions',
		defaultMessage: 'All Released Versions',
		description: 'All Released Versions option in issue navigator refinement dropdown.',
	},
	unreleasedversions: {
		id: 'jql-builder-basic.utils.get-function-label.unreleasedversions',
		defaultMessage: 'All Unreleased Versions',
		description: 'All Unreleased Versions option in issue navigator refinement dropdown.',
	},
	standardissuetypesIssueTermRefresh: {
		id: 'jql-builder-basic.utils.get-function-label.standardissuetypes-issue-term-refresh',
		defaultMessage: 'All standard work types',
		description: 'Standard issue type option in issue navigator refinement dropdown.',
	},
	subtaskissuetypesIssueTermRefresh: {
		id: 'jql-builder-basic.utils.get-function-label.subtaskissuetypes-issue-term-refresh',
		defaultMessage: 'All sub-tasks',
		description: 'Sub-task issue type option in issue navigator refinement dropdown.',
	},
});
export default messages;
